var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustApplyFormInfo.custComName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustApplyFormInfo.servicerName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.adjustApplyFormInfo.custMerchantFlag == 1 ? "是" : "否"
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustApplyFormInfo.warehouseName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.totalQuantity || 0))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.applicantName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.applyTime || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.adjustApplyFormInfo.applyState == 0
            ? _c("span", [_vm._v("未申请")])
            : _vm._e(),
          _vm._v(" "),
          _vm.adjustApplyFormInfo.applyState == 1
            ? _c("span", [_vm._v("已申请")])
            : _vm._e(),
          _vm._v(" "),
          _vm.adjustApplyFormInfo.applyState == 2
            ? _c("span", [_vm._v("已处理")])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.applyDesc || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.auditorName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.auditTime || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.adjustApplyFormInfo.auditState == 0
            ? _c("span", [_vm._v("未审核")])
            : _vm._e(),
          _vm._v(" "),
          _vm.adjustApplyFormInfo.auditState == 1
            ? _c("span", [_vm._v("审核通过")])
            : _vm._e(),
          _vm._v(" "),
          _vm.adjustApplyFormInfo.auditState == -1
            ? _c("span", [_vm._v("审核未通过")])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(12),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.auditDesc || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(13),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustApplyFormInfo.creatorName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(14),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustApplyFormInfo.createTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(15),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.accPreStkUsageMap[_vm.adjustApplyFormInfo.accPreStkUsage]
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(16),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.deltaQuantity || 0))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(17),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.adjustApplyFormInfo.deltaDesc || "无"))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(18),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.adjustApplyFormInfo.itemList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "accName",
                label: "配件名称",
                align: "left",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.specificFlag
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("个")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(scope.row.accName))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "catName",
                label: "分类",
                width: "120",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "brandName",
                label: "品牌",
                width: "120",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "modelSpec",
                label: "规格",
                width: "120",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "quantity",
                label: "申请数量",
                width: "100",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "modelSpec",
                label: "审核数量",
                width: "100",
                align: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.adjustApplyFormInfo.auditState == 1
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.quantity + rows.row.delta))
                          ])
                        : _c("span", [_vm._v("0")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "unit",
                label: "单位",
                width: "100",
                align: "center"
              }
            }),
            _vm._v(" "),
            _vm.adjustApplyFormInfo.auditState == 1
              ? _c("el-table-column", {
                  attrs: {
                    prop: "price",
                    label: "单价(元)",
                    width: "100",
                    align: "right"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "memo",
                label: "申请描述",
                width: "120",
                align: "left",
                "show-overflow-tooltip": ""
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请业务单元")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务商")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("同商户申请")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("仓库名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核人：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("备货用途")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("差异数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("差异说明")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配件信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3866f499", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3866f499","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shareAcc/AdjustApplyFormInfo.vue
// module id = 2813
// module chunks = 0